import { DaySelectComponent } from './day_select_component';
export default DaySelectComponent;
